module.exports = __webpack_public_path__ + "assets/favicons/mstile-310x310.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/mstile-310x310.png
// module id = Z0Ay
// module chunks = 1